import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getVehicleResourceMaps,
  mergeApplicationRanks,
  invalidVehicleSubconfigs,
} from '../../selectors/applications/applicationsSelector';
import { ApplicationState } from '../../reducers';

interface ApplicationEditFormHandlerProps {
  showInlineAnalyses?: boolean;
}

const ApplicationEditFormHandler: React.FC<ApplicationEditFormHandlerProps> = ({
  showInlineAnalyses,
}) => {
  const { values, setStatus } = useFormikContext<any>();

  const rankedApplications = useSelector(
    (state: ApplicationState) => state.items.application.rankedApplications
  );
  const resourceMaps = useSelector((state: ApplicationState) => getVehicleResourceMaps(state));
  const invalidVehicleSubconfigsList = useSelector((state: ApplicationState) =>
    invalidVehicleSubconfigs(state)
  );

  useEffect(() => {
    const mergedRankedApplications: any = mergeApplicationRanks(
      values.application,
      rankedApplications,
      resourceMaps,
      showInlineAnalyses ? invalidVehicleSubconfigsList : undefined
    );

    setStatus({ mergedRankedApplications });
  }, [
    invalidVehicleSubconfigsList,
    rankedApplications,
    resourceMaps,
    setStatus,
    showInlineAnalyses,
    values,
  ]);

  return null;
};

export default ApplicationEditFormHandler;
